import { FormValidationRule } from "../types";

const minCharacters: FormValidationRule = (c, v) => {
    const chars = c["minimum-characters"] || c.minLength;
    const valid = !(chars && v && v.length < parseInt(chars));
    return [
        valid,
        c.errorMessage ||
            `This field should have no less than ${chars} characters.`
    ];
};

export default minCharacters;
